import { TabTextLabel } from "@/shared/components/ui";
import { Delete } from "@mui/icons-material";
import { Grid, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton } from "@mui/material";
import { Ubicaciones } from "@/shared/interfaces/erp/inventario";
import { toast } from "react-toastify";
import { gridSizeMdLg6 } from "@/shared";
import ModalUbicacionUsuario from "./ModalUbicacionUsuario";

interface AgregarUbicacionUsuarioProps {
  dataUbicacion: Ubicaciones[]
  setDataUbicacion: React.Dispatch<React.SetStateAction<Ubicaciones[]>>
}

export default function AgregarUbicacionUsuario({
  dataUbicacion,
  setDataUbicacion
}: AgregarUbicacionUsuarioProps) {


  function addUbicacion(data: Ubicaciones) {
    const codigo = data.codigo?.trim();
    if (!codigo) return;

    setDataUbicacion((prev) => {
      if (prev.some(e => e.codigo == codigo)) {
        toast.info("Ubicación agregada");
        return prev;
      }
      return [...prev, data];
    });
  }

  function removeUbicacion(codigo: string) {
    setDataUbicacion((prev) => prev.filter((b) => b.codigo !== codigo));
  }


  return (

    <Grid item
      {...gridSizeMdLg6}
      style={{
        maxHeight: '500px',
        overflow: 'auto'
      }}
    >

      <Grid container
        justifyContent={'space-between'}
        spacing={2}
      >

        <Grid item>
          <TabTextLabel
            text={'Ubicación'}
            mt={0}
            pb={0}
            pl={0}
            pt={2}
          />
        </Grid>

        <Grid item>
          <ModalUbicacionUsuario
            onChange={addUbicacion}
          />
        </Grid>

        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Acción</TableCell>
                  <TableCell>Ubicación</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataUbicacion.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => removeUbicacion(row.codigo)}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.nombre}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

    </Grid>

  )

}